import React, { useEffect, useState, useCallback } from 'react';
import './Kanban.css';
import { useKeycloak } from '@react-keycloak/web';
import { FiLogOut } from 'react-icons/fi';
import styled from 'styled-components';

const LogoutIcon = styled(FiLogOut)`
    position: fixed;
    top: 5px;
    right: 5px;
    width: 15px;
    height: 15px;
    color: rgb(209 80 80);
    cursor: pointer;
    z-index: 1000;
`;

const Kanban = () => {
    const [pedidos, setPedidos] = useState([]);
    const [totalPronto, setTotalPronto] = useState(0);
    const [dataHoraAtual, setDataHoraAtual] = useState(new Date());
    const [newPedidos, setNewPedidos] = useState([]); 
    const [isAudioEnabled, setIsAudioEnabled] = useState(false);
    const [showPopup, setShowPopup] = useState(true);
    const { keycloak } = useKeycloak();

    // Debug do token e company_id
    useEffect(() => {
    }, [keycloak.tokenParsed]);

    const playSound = useCallback(() => {
        if (isAudioEnabled) {
            const audio = new Audio('/notification.mp3');
            audio.play().catch(error => {
                console.log("Erro ao reproduzir o som:", error);
            });
        }
    }, [isAudioEnabled]);

    const enableAudio = () => {
        setIsAudioEnabled(true);
        setShowPopup(false);
    };

    useEffect(() => {
        const socket = new WebSocket(`wss://supriseg-separacao.dataplace.app?company_id=${keycloak.tokenParsed.company_id}`);
        
        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            const newPedidosArr = data.filter(pedido => 
                pedido.Status === 'A Separar' && 
                !pedidos.some(existingPedido => existingPedido.Pedido === pedido.Pedido)
            );
            
            if (newPedidosArr.length > 0) {
                playSound();
                setNewPedidos(newPedidosArr);
                setTimeout(() => setNewPedidos([]), 5000);
            }
            
            //setPedidos(data.sort((a, b) =>  new Date(b.Data) - new Date(a.Data)));
            setPedidos(data.sort((a, b) =>  b.Pedido - a.Pedido));

            const totalProntoCount = data.filter(pedido => pedido.Status === 'Pronto').length;
            setTotalPronto(totalProntoCount);
        };

        return () => {
            socket.close();
        };
    }, [pedidos, playSound]);

    useEffect(() => {
        const interval = setInterval(() => {
            setDataHoraAtual(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const buckets = {
        "A Separar": [],
        "Em Separação": [],
        "A Conferir": [],
        "Pronto": []
    };

    pedidos.forEach(pedido => {
        buckets[pedido.Status].push(pedido);
    });

    const formatDate = (dateString, withhour) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Adiciona zero à esquerda se necessário
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        if(withhour){
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }else{
            return `${day}/${month}/${year}`;
        }
        
    };

    return (
        <div className="kanban-container">
           {showPopup && (
                <div className="popup">
                    <h2>Bem-vindo!</h2>
                    <p>Para habilitar o áudio, clique no botão abaixo:</p>
                    <button onClick={enableAudio}>Habilitar Áudio</button>
                </div>
            )}
            <LogoutIcon onClick={() => keycloak.logout()} />
            <header className="kanban-header">
                <img 
                    src="https://gruposupritec.com.br/uploads/loja_logo/24/c507ad7e71a46856a60fdc95e41669fe.png" 
                    alt="Logotipo" 
                    className="kanban-logo"
                />
                <div className="kanban-date-time">
                    {formatDate(dataHoraAtual, true)}
                </div>
                <div className="kanban-total-card">
                    <h4>Total de Pedidos Prontos</h4>
                    <div className="kanban-total-quantity">{totalPronto}</div>
                </div>
            </header>

            <div className="kanban-bucket-container">
                {Object.keys(buckets).map(bucketName => (
                    <div key={bucketName} className="kanban-bucket">
                        <h3 className="kanban-title">{bucketName}</h3>
                        {buckets[bucketName].map(pedido => (
                            <div key={pedido.Pedido} className={`kanban-card ${bucketName === "A Separar" && newPedidos.some(newPedido => newPedido.Pedido === pedido.Pedido) ? 'pulse' : ''}`}>
                                <strong>Pedido:</strong> {pedido.Pedido}<br />
                                <strong>Cliente:</strong> {pedido.Cliente}<br />
                                <strong>Data:</strong> {formatDate(pedido.Data, false)}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Kanban;
